/* istanbul ignore file */
import React from 'react';
import { useEmployeeService, useEmployeeUrl } from 'domain/shared/employee';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import EmployeesBreadcrumbs from 'domain/people/employee/shared/EmployeesBreadcrumbs';

const SingleEmployeeBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getFullName } = useEmployeeService();
  const { getTimelineUrl } = useEmployeeUrl();
  const id = data.getValueBySource('alias');

  const firstName = data.getValueBySource('nameEn.firstName');
  const lastName = data.getValueBySource('nameEn.lastName');
  const maidenName = data.getValueBySource('nameEn.maidenName');

  const displayedName = getFullName({ firstName, lastName, maidenName });

  return (
    <EmployeesBreadcrumbs>
      <SingleBreadcrumbItem entity={displayedName} link={getTimelineUrl(id)} />
      {children}
    </EmployeesBreadcrumbs>
  );
};

export default SingleEmployeeBreadcrumbs;
